import { MortgageCampaignInterface } from 'common/module/mortgage/campaign.interface';
import { MortgageCampaignSaroutycreditsimulatorViewStore } from 'common/module/mortgage/campaign/saroutycreditsimulator/view-store';
import { MortgageCampaignOptionsInterface } from 'common/module/mortgage/campaign-options.interface';
import { ViewDynamicInterface } from 'common/module/view/dynamic.interface';

export class MortgageCampaignSaroutycreditsimulatorView implements MortgageCampaignInterface {
  /**
   * Main HTML view element
   */
  private element: HTMLElement;

  /**
   * Constructor
   */
  constructor(private viewDynamic: ViewDynamicInterface<MortgageCampaignSaroutycreditsimulatorViewStore>) {}

  /**
   * @inheritDoc
   */
  public initialize(options: MortgageCampaignOptionsInterface): void {
    this.element = options.element;

    this.viewDynamic.initialize({
      element: this.element,
    });

    this.viewDynamic.getViewStore().initialize();
  }

  /**
   * @inheritDoc
   */
  public render(): void {
    this.viewDynamic.render();
  }
}
